export enum VolumeType {
  MultiPlane,
  LowestPlane
}

export enum SamplingRate {
  High=0.25,
  Medium=0.5,
  Low=1.0
}

export enum MeasureType {
  Length="length",
  SnapUp="snap-up",
  SnapDown="snap-down",
  Height="height",
  Point="point",
  Area="area",
  Volume="volume",
  Station="station_measurement"
}